import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useAtualizarPerfil, useAlterarSenhaPerfil } from '../../hooks/usePerfil';
import { usePageTitle } from '../../hooks/usePageTitle';
import Button from '../../components/Common/Button';
import toast from 'react-hot-toast';

const Perfil: React.FC = () => {
  usePageTitle('Perfil');
  const { user, updateUser } = useAuth();

  const [nome, setNome] = useState(user?.nome ?? '');
  const [email, setEmail] = useState(user?.email ?? '');

  const [senhaAtual, setSenhaAtual] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmarNovaSenha, setConfirmarNovaSenha] = useState('');

  const { mutate: atualizarPerfil, isPending: salvandoPerfil } = useAtualizarPerfil();
  const { mutate: alterarSenha, isPending: alterandoSenha } = useAlterarSenhaPerfil();

  useEffect(() => {
    if (user) {
      setNome(user.nome);
      setEmail(user.email);
    }
  }, [user]);

  const handleSalvarDados = (e: React.FormEvent) => {
    e.preventDefault();
    atualizarPerfil(
      { nome, email },
      {
        onSuccess: (data) => {
          updateUser({ nome: data.nome, email: data.email });
          toast.success('Dados atualizados com sucesso!');
        },
      }
    );
  };

  const handleAlterarSenha = (e: React.FormEvent) => {
    e.preventDefault();
    alterarSenha(
      { senhaAtual, novaSenha, confirmarNovaSenha },
      {
        onSuccess: (data) => {
          toast.success(data.mensagem);
          setSenhaAtual('');
          setNovaSenha('');
          setConfirmarNovaSenha('');
        },
      }
    );
  };

  const inputClass =
    'w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500';
  const labelClass = 'block text-sm font-medium text-gray-700 mb-1';

  return (
    <div className="max-w-2xl mx-auto space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-gray-800">Meu Perfil</h1>
        <p className="text-gray-500 text-sm mt-1">Gerencie suas informações pessoais</p>
      </div>

      {/* Dados pessoais */}
      <div className="bg-white rounded-lg shadow p-6">
        <h2 className="text-lg font-semibold text-gray-800 mb-4">Dados Pessoais</h2>
        <form onSubmit={handleSalvarDados} className="space-y-4">
          <div>
            <label className={labelClass}>Nome</label>
            <input
              type="text"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              className={inputClass}
              required
            />
          </div>
          <div>
            <label className={labelClass}>E-mail</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={inputClass}
              required
            />
          </div>
          <div className="pt-2">
            <Button type="submit" variant="primary" size="md" disabled={salvandoPerfil}>
              {salvandoPerfil ? 'Salvando...' : 'Salvar Dados'}
            </Button>
          </div>
        </form>
      </div>

      {/* Alterar senha */}
      <div className="bg-white rounded-lg shadow p-6">
        <h2 className="text-lg font-semibold text-gray-800 mb-4">Alterar Senha</h2>
        <form onSubmit={handleAlterarSenha} className="space-y-4">
          <div>
            <label className={labelClass}>Senha Atual</label>
            <input
              type="password"
              value={senhaAtual}
              onChange={(e) => setSenhaAtual(e.target.value)}
              className={inputClass}
              required
              autoComplete="current-password"
            />
          </div>
          <div>
            <label className={labelClass}>Nova Senha</label>
            <input
              type="password"
              value={novaSenha}
              onChange={(e) => setNovaSenha(e.target.value)}
              className={inputClass}
              required
              minLength={6}
              autoComplete="new-password"
            />
          </div>
          <div>
            <label className={labelClass}>Confirmar Nova Senha</label>
            <input
              type="password"
              value={confirmarNovaSenha}
              onChange={(e) => setConfirmarNovaSenha(e.target.value)}
              className={inputClass}
              required
              autoComplete="new-password"
            />
          </div>
          <div className="pt-2">
            <Button type="submit" variant="primary" size="md" disabled={alterandoSenha}>
              {alterandoSenha ? 'Alterando...' : 'Alterar Senha'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Perfil;
